import { combineReducers } from 'redux';
import HeaderConfig from './HeaderConfigs'; //标题头
import LoadingConfig from './LoadingConfig';
export default combineReducers({
  HeaderConfig,
  LoadingConfig,
});
